<div class="ir-area ir-header th-header">
  <div class="ir-line th-header-line header">
    <div class="ir-line--left left">
      <img src="/Content/svg/client-logo.svg" class="ir-logo" />
    </div>
    <div class="ir-line--right right">
      <div>
        <ng-container *ngIf="buttons$ | async as buttons">
          <div *ngFor="let button of buttons" class="ir-btn th-btn-normal" (click)="openLink(button.link)">
            <i class="material-icons">{{ button.icon }}</i>
          </div>
        </ng-container>
        <div class="ir-btn th-btn-icon" *ngIf="!isConnection">
          <i class="material-icons">portable_wifi_off</i>
        </div>
        <div class="ir-btn th-btn-normal" *ngIf="isConnection" (click)="openLanguagesSelector()">
          <span>{{ currentLanguage }}</span>
        </div>
        <div class="ir-btn th-btn-normal" *ngIf="isConnection" (click)="openVersionPopup()">
          <i class="material-icons">info</i>
        </div>
        <div class="ir-btn th-btn-normal" *ngIf="isConnection" [routerLink]="['settings']">
          <i class="material-icons">settings</i>
        </div>
        <div
          *ngIf="isConnection"
          [permissions]="[['visible', 'manage.template']]"
          [routerLink]="['/inspectionbrowser/admin']"
          class="ir-btn th-btn-normal"
          title="{{ 'home.administration' | translate }}"
        >
          <i class="material-icons">admin_panel_settings</i>
        </div>
        <div
          class="ir-btn th-btn-normal"
          *ngIf="isConnection && currentPerson.applicationTypes.length > 1"
          (click)="openAppSelector()"
        >
          <i class="material-icons">apps</i>
        </div>
        <div class="ir-btn th-btn-normal" *ngIf="isConnection" (click)="openLogout()">
          <i class="material-icons">power_settings_new</i>
        </div>
      </div>
    </div>
    <div class="ir-line-content">
      <span>{{ 'home.dashboard' | translate }}</span>
    </div>
  </div>
</div>
<div class="ir-area ir-body th-body">
  <div class="ir-pv4 ir-ph4 content">
    <div class="actions">
      <div class="card welcome-card">
        <div class="welcome-text">
          <span class="inspection">{{ dashboardTitleLabel | translate }}</span>
          <div>
            <span class="welcome-back">{{ 'home.welcome-back' | translate }}</span>
            <br />
            <span class="person-name">{{ currentPerson?.name }}</span>
          </div>
        </div>
        <div class="th-txt">
          <span
            (click)="openInspection(upcomingInspection.id)"
            *ngIf="upcomingInspection?.equipment && !offlineInspection"
            class="inspection"
            [innerHtml]="'home.upcoming-inspection' | translate : upcomingInspection"
          ></span>

          <span
            (click)="openInspection(offlineInspection.id)"
            *ngIf="offlineInspection?.data?.machine?.name"
            class="inspection"
            [innerHtml]="'offline.home.offline-inspection' | translate : offlineInspection"
          ></span>
        </div>
      </div>
      <div class="actions-buttons">
        <div
        [routerLink]="['/inspectionbrowser/customers']"
          class="ir-btn ir-btn--block min-width"
          [ngClass]="isConnection ? 'th-btn-action' : 'th-btn-disabled'"
        >
          <div class="button-conent">
            <i class="material-icons">contacts</i>
            <span>{{ 'home.customers' | translate }}</span>
          </div>
        </div>
        <div
          (click)="newInspection()"
          class="ir-btn ir-btn--block min-width"
          [ngClass]="isConnection ? 'th-btn-action' : 'th-btn-disabled'"
        >
          <div class="button-conent">
            <i class="material-icons">playlist_add</i>
            <span>{{ newInspectionLabel | translate }}</span>
          </div>
        </div>
        <div (click)="openInspections()" class="ir-btn ir-btn--block th-btn-action min-width">
          <div class="button-conent">
            <i class="material-icons">playlist_play</i>
            <span>{{ inspectionsLabel | translate }}</span>
          </div>
        </div>
        <div [routerLink]="['/inspectionbrowser/actionPlans']" class="ir-btn ir-btn--block th-btn-action min-width">
          <div class="button-conent">
            <i class="material-icons">playlist_add_check</i>
            <span>{{ 'home.action-plan' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="statistic min-width">
      <div class="card card-inprogress" [class.disabled]="!isConnection">
        <div class="title">
          <span class="title-text">{{ inProgressLabel | translate }}</span>
          <i (click)="openInspectionsInProgress()" class="material-icons">call_made</i>
        </div>
        <div
          *ngIf="dashboardStatistic?.inspectionInProgress?.length; else noInspectionsInprogress"
          class="inspections-inprogress th-txt"
        >
          <button
            (click)="openInspection(item.id)"
            *ngFor="let item of dashboardStatistic?.inspectionInProgress | slice : 0 : 2"
            class="ir-btn ir-btn--block ir-btn--title min-width"
          >
            <div class="inspection-button-content">
              <span>
                <strong>{{ item.equipment }}</strong>
              </span>
              <i class="material-icons">arrow_forward_ios</i>
            </div>
          </button>
        </div>
        <ng-template #noInspectionsInprogress>
          <span class="text">{{ 'home.no-inspections-in-progress' | translate }}</span>
        </ng-template>
      </div>
      <div class="numbers">
        <div class="card card-number min-width">
          <div class="number th-txt">
            <span class="number-text">
              <strong>{{ dashboardStatistic?.inspectionsLastMonthCount }}</strong>
            </span>
            <span class="inspections">{{ inspectionsStatisticLabel | translate }}</span>
            <span class="status">{{ 'home.performed-last-month' | translate }}</span>
          </div>
        </div>
        <div class="card card-number min-width">
          <div class="number th-txt">
            <span class="number-text">
              <strong>{{ dashboardStatistic?.inspectionsOnReviewCount }}</strong>
            </span>
            <span class="inspections">{{ inspectionsStatisticLabel | translate }}</span>
            <span class="status">{{ 'home.in-review' | translate }}</span>
          </div>
        </div>
      </div>
      <div class="card card-upcoming" [class.disabled]="!isConnection">
        <div class="title">
          <span class="title-text">{{ upcomingInspectionsLabel | translate }}</span>
          <i (click)="openUpcomingInspections()" class="material-icons">call_made</i>
        </div>
        <div
          *ngIf="dashboardStatistic?.inspectionsUpcoming?.length; else noUpcomingInspections"
          class="inspections-upcoming th-txt"
        >
          <button
            (click)="openInspection(item.id)"
            *ngFor="let item of dashboardStatistic?.inspectionsUpcoming | slice : 0 : 2"
            class="ir-btn ir-btn--block ir-btn--title min-width"
          >
            <div class="inspection-button-content">
              <span>
                {{ item.startDate | formatDate }}, <strong>{{ item.equipment }}</strong
                >, {{ item.customer }}
              </span>
              <i class="material-icons">arrow_forward_ios</i>
            </div>
          </button>
        </div>
        <ng-template #noUpcomingInspections>
          <span class="text">{{ noUpcomingInspectionsLabel | translate }}</span>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<modal (modalOutput)="selectLanguagesMenu($event)" #languagesModal></modal>
<modal (modalOutput)="selectAppMenu($event)" #appModal></modal>
<modal #versionModal></modal>
<information
  #inspectionOfflineReminder
  (confirmOutput)="goToInspections()"
  [title]="'offline.home.inform-alert.title' | translate"
  [message]="'offline.home.inform-alert.message' | translate"
  [danger]="true"
></information>
<confirm
  #syncronizationReminder
  (modalClosed)="logout()"
  [title]="'offline.inspection-remove-modal.title' | translate"
  [message]="'offline.home.synchronize-alert.message' | translate"
  [okButtonText]="'offline.home.synchronize-alert.ok' | translate"
  [cancelButtonText]="'offline.home.synchronize-alert.cancel' | translate"
  [danger]="true"
></confirm>
